import { PlantItemRenewalConstants } from 'plantItemRenewal/constants/plantItemRenewalConstants';
import { getQuestionAnswers } from 'shared/utils/FormatHelper';
import { splitFullName } from 'shared/utils/Helpers';
import { getItemsSearchedByType } from './PlantItemRenewalHelpers';
import { formatPlantItemRenewalSummary } from './PlantItemRenewalSummaryFormatHelper';

const generatePlantItemRenewalFormattedApplication = (state) => {
  const {
    application: app,
    referenceData: ref,
    plantItemRenewalApplicantDetails: applicantDetails,
    renewalItems,
  } = state;

  let formattedApplication = {
    applicationId: app.applicationId,
    applicationNo: app.applicationNo,
    licenceType: app.licenceType,
    plantTransactionType: PlantItemRenewalConstants.transactionType,
    applicantType: PlantItemRenewalConstants.applicantType,
    durationRequested: PlantItemRenewalConstants.licenceDuration,
    parentRSN: renewalItems.folderRsn,
    individualApplicantDetails: formattedIndividualApplicant(applicantDetails), // todo check for individual or organisation ?
    organisationApplicantDetails: formatOrganisationDetails(renewalItems.people),
    questionList: formatQuestionList(),
    contactDetails: formatContactDetails(applicantDetails),
    attachments: [],
    renewalNumber: renewalItems.renewalNumber,
    tangibleId: renewalItems.itemRegistrationNumber,
    tangiblePostCode: renewalItems.itemLocationPostcode,
    renewalItems: renewalItems.items,
    jobTitle: applicantDetails.jobTitle,
    applicationSummary: formatPlantItemRenewalSummary(state),
    propertyAddress: renewalItems.property[0]?.propAddress,
    itemsSearchedBy: getItemsSearchedByType(renewalItems.searchBy),
  };

  return formattedApplication;
};

const formattedIndividualApplicant = (applicantDetails) => {
  //todo: Modify this method once contact details page is ready

  const names = splitFullName(applicantDetails?.fullName);

  return {
    roles: ['Applicant'],
    id: 'applicant1',
    firstName: names.firstName,
    surname: names.lastName,
    email: applicantDetails.emailAddress,
  };
};

const formatOrganisationDetails = (people) => {
  const peopleRecord = people?.length && people[0];

  // The type starts with an upper case letter here
  if (
    !peopleRecord ||
    peopleRecord.type !== PlantItemRenewalConstants.peopleRecordType.organisation ||
    !peopleRecord.holderName
  )
    return null;

  return {
    name: peopleRecord.holderName,
    abn: peopleRecord.abn,
  };
};

const formatQuestionList = (disclosures, disclosuresRefData) => {
  return [
    {
      questionGroupDescription: 'Disclosures',
      questionAnswers: getQuestionAnswers(),
    },
  ];
};

const formatContactDetails = (applicantDetails) => {
  const { emailAddress, changeEmail, newEmailAddress, phoneNumber } = applicantDetails;

  const contactEmail = changeEmail === 'yes' ? newEmailAddress : emailAddress;
  const isMobile = phoneNumber.type === 'mobile';
  const mobileNumber = isMobile ? phoneNumber.formattedNumber : null;
  const landlineNumber = isMobile ? null : phoneNumber.formattedNumber;

  return [
    {
      email: contactEmail,
      mobileNumber,
      landlineNumber,
    },
  ];
};

export { generatePlantItemRenewalFormattedApplication };
